import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group'

import { Button } from '@salesforce/design-system-react';

const propTypes = {
  pause: PropTypes.node,
  recap: PropTypes.node,
  title: PropTypes.string,
  nextLabel: PropTypes.string,
  nextFunc: PropTypes.func
};

class RecapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRecap: true
    }
    this.summaryTitle = React.createRef();
  }

  componentDidMount() {
    this.summaryTitle.current.focus();
  }

  renderPause() {
    return (
      <section>
        <h2 className='pbl'>Before we continue...</h2>
        {this.props.pause}
        <Button
          className='mvl'
          label='What was this step all about?'
          onClick={() => {this.setState({showRecap: true})}}
          variant='neutral' />
      </section>
    );
  }

  renderRecap() {
    return (
      <section>
        <h2 tabIndex='-1' ref={this.summaryTitle} className='pal bg-recap no-focus-halo'>
          Summary: {this.props.title}
        </h2>
        <div className='pal'>
          {this.props.recap}
          <Button
            className='mvl'
            label={this.props.nextLabel}
            onClick={this.props.nextFunc}
            variant='neutral' />
        </div>
      </section>
    );
  }

  render() {
    return (
      <section className='bg-darkblue recap-container' aria-label={`Summary: ${this.props.title}`}>
        <CSSTransitionGroup
          transitionName="recap"
          transitionAppear={true}
          transitionEnter={true}
          transitionLeave={false} 
          transitionAppearTimeout={500} 
          transitionEnterTimeout={500}>
          { this.state.showRecap ? this.renderRecap() : this.renderPause() }
        </CSSTransitionGroup>
      </section>
    );
  }
}

RecapContainer.propTypes = propTypes;
export default RecapContainer;




// WEBPACK FOOTER //
// ./src/containers/recapContainer/index.js